export const loadState = (key) => {
  try {
    let savedState = localStorage.getItem(key);
    if (savedState) {
      savedState = JSON.parse(savedState);
    }
    return savedState;
  } catch (err) {
    console.error("Could not load saved state:", err);
  }
};

export const persistState = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error("Could not save state:", err);
  }
};
